exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app {\n  min-height: 100%;\n  position: relative; }\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%; }\n\n@media screen and (max-width: 844px) {\n  .rwd-class {\n    padding: 0 !important; } }\n", "", {"version":3,"sources":["/usr/src/app/src/components/ServicesLayout/ServicesLayout2.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,UAAU;EACV,WAAW;EACX,aAAa,EAAE;;AAEjB;EACE;IACE,sBAAsB,EAAE,EAAE","file":"ServicesLayout2.scss","sourcesContent":["#app {\n  min-height: 100%;\n  position: relative; }\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%; }\n\n@media screen and (max-width: 844px) {\n  .rwd-class {\n    padding: 0 !important; } }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/ServicesLayout/ServicesLayout2.scss
// module id = 1049
// module chunks = 0